import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { RejectReturnRequestLineItemsBodyDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

interface UseRejectReturnRequestParams {
  onSuccess: () => void;
  onMutate: () => void;
  onError?: () => void;
  shopId: string;
}

export default function useRejectReturnRequest(
  params: UseRejectReturnRequestParams,
) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const invalidateShop = useInvalidateShop(params.shopId);
  const mutation = $api.useMutation("post", "/shops/{shopId}/return-requests/{returnRequestId}/line-items/reject");

  return useMutation({
    onMutate: () => params.onMutate(),
    onSuccess: () => {
      invalidateShop();
      successNotification();
      params.onSuccess();
    },
    onError: () => {
      params.onError?.();
      errorNotification();
    },

    mutationFn: async ({
      variables,
      returnRequestId,
    }: {
      variables: RejectReturnRequestLineItemsBodyDto;
      returnRequestId: string;
    }) => {
      return mutation.mutateAsync({
        params: { path: { shopId: params.shopId, returnRequestId } },
        body: variables,
      });
    },
  });
}
